import React, { ReactElement } from 'react';
import styles from './styles.module.scss';
import classNames from 'classnames';

export const FusionSectionCaption: React.FC<{ children: React.ReactNode; className?: string }> = ({
  children,
  className,
}) => {
  return <p className={classNames(styles.fusionSectionCaption, className)}>{children}</p>;
};

export default FusionSectionCaption;
